module.exports = __webpack_public_path__ + "static/media/gestioneCandidatureTCB.fb2d77ff.png";